// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"text-area_wrapper__2U0ev","label":"text-area_label__2jo1M","textarea":"text-area_textarea__13JGD"};